export const getEnvEndpoints = () => {
  const isUpgrade = Boolean(process.env.REACT_APP_SERVER_UPGRADE && process.env.REACT_APP_SERVER_UPGRADE === "1");
  if (isUpgrade) {
    return {
      REACT_APP_BASE_MEDIA_URL: process.env.REACT_APP_BASE_MEDIA_URL_NEW || 'https://management-idbf.inexture.in',
      REACT_APP_BASE_MEDIA_URL2: process.env.REACT_APP_BASE_MEDIA_URL2_NEW || 'https://management-idbf.inexture.in/es/',
      REACT_APP_ESUSERNAME: process.env.REACT_APP_ESUSERNAME_NEW,
      REACT_APP_ESPSW: process.env.REACT_APP_ESPSW_NEW,
      REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL: process.env.REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL_NEW || 'https://zappa-tlaqv351d-osn.s3.amazonaws.com/media/',
    }
  } else if (Boolean(process.env.REACT_APP_SERVER_UPGRADE && process.env.REACT_APP_SERVER_UPGRADE === "elastic")) {
    return {
      REACT_APP_BASE_MEDIA_URL: process.env.REACT_APP_BASE_MEDIA_URL_NEW || 'https://management-idbf-stg.inexture.com',
      REACT_APP_BASE_MEDIA_URL2: process.env.REACT_APP_BASE_MEDIA_URL2_NEW || 'https://management-idbf-stg.inexture.com/es/',
      REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL: process.env.REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL_NEW || 'https://zappa-tlaqv351d-osn.s3.amazonaws.com/media/',
    }
  } else {  
    return {
      REACT_APP_BASE_MEDIA_URL: process.env.REACT_APP_BASE_MEDIA_URL || 'https://management.100procentlokaal.be',
      REACT_APP_BASE_MEDIA_URL2: process.env.REACT_APP_BASE_MEDIA_URL2 || 'https://management.100procentlokaal.be/es/',
      REACT_APP_ESUSERNAME: process.env.REACT_APP_ESUSERNAME,
      REACT_APP_ESPSW: process.env.REACT_APP_ESPSW,
      REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL: process.env.REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL || 'https://zappa-tlaqv351d-prd.s3.amazonaws.com/media/',
    }
  }
};

//websites ENV URL constants 
const ENVIRONMENTS = {
  dev: {
    SERVER_UPGRADE: "dev",
    DOMAIN_URL: "migration.100procentlokaal.be",
    '100_POURCENT_DOMAIN_URL': "migration.100pourcentlocale.be",
    ONDERNEMERSNETWERK_DOMAIN_URL: "migration.ondernemersnetwerk.be",
    RESEAUENTREPRENEURS_DOMAIN_URL: "migration.reseauentrepreneurs.be",
    WIJZIG_DOMAIN_URL: "migration.wijzig.100procentlokaal.be",
    CATALOGOUS_DOMAIN_URL: "migration.catalogusnetwerk.be",
    PROMONETWERK_DOMAIN_URL: "migration.promonetwerk.be",
    RESEAUPROMO_DOMAIN_URL:"migration.reseaupromo.be",
    RESEAUCATALOGUE_DOMAIN_URL:"migration.reseaucatalogue.be",
    IMAGE_THUMBNAIL_URL_NEW:"https://zappa-tlaqv351d-osn.s3.amazonaws.com/media/"
  },
  staging: {
    SERVER_UPGRADE: "staging",
    DOMAIN_URL: "staging.100procentlokaal.be",
    '100_POURCENT_DOMAIN_URL': "staging.100pourcentlocale.be",
    ONDERNEMERSNETWERK_DOMAIN_URL: "staging.ondernemersnetwerk.be",
    RESEAUENTREPRENEURS_DOMAIN_URL: "staging.reseauentrepreneurs.be",
    WIJZIG_DOMAIN_URL: "staging.wijzig.100procentlokaal.be",
    CATALOGOUS_DOMAIN_URL: "staging.catalogusnetwerk.be",
    PROMONETWERK_DOMAIN_URL: "staging.promonetwerk.be",
    RESEAUPROMO_DOMAIN_URL:"staging.reseaupromo.be",
    RESEAUCATALOGUE_DOMAIN_URL:"staging.reseaucatalogue.be",
    IMAGE_THUMBNAIL_URL_NEW:"https://zappa-tlaqv351d-osn.s3.amazonaws.com/media/"
  },
  elastic: {
    SERVER_UPGRADE: "elastic",
    DOMAIN_URL: "elastic.100procentlokaal.be",
    '100_POURCENT_DOMAIN_URL': "elastic.100pourcentlocale.be",
    ONDERNEMERSNETWERK_DOMAIN_URL: "elastic.ondernemersnetwerk.be",
    RESEAUENTREPRENEURS_DOMAIN_URL: "elastic.reseauentrepreneurs.be",
    WIJZIG_DOMAIN_URL: "elastic.wijzig.100procentlokaal.be",
    CATALOGOUS_URL: "elastic.catalogusnetwerk.be",
    PROMONETWERK_DOMAIN_URL: "elastic.promonetwerk.be",
    RESEAUPROMO_DOMAIN_URL:"elastic.reseaupromo.be",
    RESEAUCATALOGUE_DOMAIN_URL:"elastic.reseaucatalogue.be",
    IMAGE_THUMBNAIL_URL_NEW:"https://zappa-tlaqv351d-osn.s3.amazonaws.com/media/"
  },
  production: {
    SERVER_UPGRADE: "production",
    DOMAIN_URL: "100procentlokaal.be",
    '100_POURCENT_DOMAIN_URL': "100pourcentlocale.be",
    ONDERNEMERSNETWERK_DOMAIN_URL: "ondernemersnetwerk.be",
    RESEAUENTREPRENEURS_DOMAIN_URL: "reseauentrepreneurs.be",
    WIJZIG_DOMAIN_URL: "wijzig.100procentlokaal.be",
    CATALOGOUS_DOMAIN_URL: "catalogusnetwerk.be",
    PROMONETWERK_DOMAIN_URL: "www.promonetwerk.be",
    RESEAUPROMO_DOMAIN_URL:"www.reseaupromo.be",
    RESEAUCATALOGUE_DOMAIN_URL:"www.reseaucatalogue.be",
    IMAGE_THUMBNAIL_URL_NEW:"https://zappa-tlaqv351d-prd.s3.amazonaws.com/media/"
  },
};

/**
 * Returns the environment config based on REACT_APP_SERVER_UPGRADE
 * Defaults to 'production' if not set or invalid
 */
export function getEnvironmentConfig() {
  const env = process.env.REACT_APP_SERVER_UPGRADE?.toLowerCase() || "production";
  return ENVIRONMENTS[env] || ENVIRONMENTS.production;
}
